export class ClienteClassificacao {
    codigo: string;
    descricao: string;
}
